import type React from 'react';
import { RatingTooltip } from './RatingTooltip';
import { StarRating } from './StarRating';

// Port of legacy StarRating/StackedLayout + HorizontalLayout. Both render 19px/6px stars,
// an optional bold numeric, and a "NerdWallet rating" review link + RatingTooltip row.
// stacked: stars above the number/link row (marginTop 2 = 8px).
// horizontal: stars inline-left of the number (marginRight 9px), link row below.
export function RatingSummary({
  starRating,
  starRatingTooltip,
  reviewLink,
  hideNumber = false,
  align = 'start',
  layout = 'stacked',
}: {
  starRating?: number;
  starRatingTooltip?: string;
  reviewLink?: string | null;
  hideNumber?: boolean;
  align?: 'start' | 'center' | 'end';
  layout?: 'stacked' | 'horizontal';
}): React.JSX.Element | string {
  if (!starRating) return 'Not yet rated';

  const alignClass =
    align === 'center' ? 'items-center' : align === 'end' ? 'items-end' : 'items-start';

  const numeric =
    !hideNumber && starRating !== 0 ? (
      <strong className="mr-1 inline-block font-bold">{starRating.toFixed(1)}</strong>
    ) : null;

  const linkRow = (
    <span className="whitespace-nowrap">
      {reviewLink ? (
        <a href={reviewLink} target="_blank">
          NerdWallet rating{' '}
        </a>
      ) : (
        <>NerdWallet rating </>
      )}
      {starRatingTooltip && <RatingTooltip starRatingTooltip={starRatingTooltip} />}
    </span>
  );

  if (layout === 'horizontal') {
    return (
      <div className={`flex flex-col ${alignClass}`} data-testid="rating-component">
        <div className="flex">
          <StarRating className="mt-[2px] mr-[9px]" gap="6px" size="19px" value={starRating} />
          {numeric}
        </div>
        <div>
          <span className="inline-block">{linkRow}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col ${alignClass}`} data-testid="rating-component">
      <StarRating gap="6px" size="19px" value={starRating} />
      <div className="mt-2">
        {numeric}
        <span className="inline-block">{linkRow}</span>
      </div>
    </div>
  );
}
